import React from "react"
import {CmCollection, CmTeasable} from "../../../../packages/graphql-layer/src";
import CCOHeadline from "../../fundamentals/CCOHeadline";


export interface Props {
    cmCollection: CmCollection
}

function C999E2ETest(props: Props) {
    return <>
        <CCOHeadline headline={props.cmCollection.teaserTitle}/>
        <ol data-cypress={"preview-docTypes"} > {
            props.cmCollection.items?.map(i => i as CmTeasable).map((i: CmTeasable, index: number) =>
                <li key={index}>
                    <strong>{i.type+ '/' + i.id}</strong>
                </li>
            )
        }
        </ol>
    </>
}

export default C999E2ETest